var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "alert-large alert-large-info" }, [
        _c("div", { staticClass: "icon-container" }, [
          _c("i", { staticClass: "fa fa-exclamation" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "alert-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12 col-md-6 col-lg-7" }, [
              _c("p", { staticClass: "lead m-b-none" }, [
                _vm._v("Accept Terms and Conditions"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "m-b-none" }, [
                _vm._v(
                  "Your booking is not confirmed until they are accepted and your deposit is paid."
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "visible-sm visible-xs m-b-sm" }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 col-lg-5 text-right" },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-info btn-block",
                    attrs: {
                      href: "#",
                      "data-toggle": "modal",
                      "data-target": "#modal-terms",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-text" }),
                    _vm._v(" Terms and Conditions"),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }